import React from "react";

// Top-level safety net: a render crash shows this panel (with the error) instead of a blank page.
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error("uReserve render crash:", error, info?.componentStack);
  }

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;
    const firstFrames = (info?.componentStack || "").trim().split("\n").slice(0, 6).join("\n");
    return (
      <div style={{ padding: 32, fontFamily: "Source Sans 3, sans-serif", color: "#1C4E80", maxWidth: 820 }} data-testid="app-error-boundary">
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>Something went wrong loading this screen.</h1>
        <p style={{ color: "#5A6B75", fontSize: 14, marginBottom: 16 }}>
          Please take a screenshot of this message and send it to support, then click Reload.
        </p>
        <pre style={{ background: "#F5F7FA", border: "1px solid #D6DCE3", padding: 12, fontSize: 12, whiteSpace: "pre-wrap", color: "#B4331A" }} data-testid="app-error-message">
          {String(error?.message || error)}
          {firstFrames ? `\n\n${firstFrames}` : ""}
        </pre>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{ marginTop: 16, background: "#1C4E80", color: "#fff", padding: "6px 14px", borderRadius: 3, fontSize: 13, fontWeight: 600 }}
          data-testid="app-error-reload"
        >
          Reload
        </button>
      </div>
    );
  }
}
